import { default as Mui5Modal, ModalProps as Mui5ModalProps } from '@mui/material/Modal'
import { forwardRef } from 'react'
import { ModalContent } from '../other/modal/ModalContent'
import { ButtonProps } from './Button'

export type OsModalProps = Omit<Mui5ModalProps, 'children'> & {
  children?: React.ReactNode
  headerTitle?: string
  headerSubtitle?: string
  modalContent?: React.ReactNode
  acceptButtonProps?: ButtonProps
  cancelButtonProps?: ButtonProps
  tertiaryButtonProps?: ButtonProps
  acceptButtonLabel?: string
  cancelButtonLabel?: string
  tertiaryButtonLabel?: string
  onClickAcceptButton?: (value: any) => any
  onClickCancelButton?: (value: any) => any
  onClickTertiaryButton?: (value: any) => any
  onClickCloseButton?: () => void
  size?: 'xSmall' | 'small' | 'medium' | 'large'
  modalType?: 'default' | 'onboarding'
}

export const Modal = forwardRef<HTMLDivElement, OsModalProps>(({ ...props }, ref) => {
  const { children, headerTitle, headerSubtitle, modalContent, ...rest } = props
  return (
    <Mui5Modal ref={ref} {...rest}>
      <>{children || <ModalContent {...props} />}</>
    </Mui5Modal>
  )
})
